import { render, staticRenderFns } from "./AssignToolToTheClientPage.vue?vue&type=template&id=2170dcce"
import script from "./AssignToolToTheClientPage.vue?vue&type=script&lang=js"
export * from "./AssignToolToTheClientPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports